var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body",attrs:{"ui-view":"","id":"view"}},[_c(_vm.component,{tag:"component",attrs:{"board-title":"개인정보처리방침관리","board-name":"privacyPolicy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }